import { useTranslation } from 'react-i18next';

import { TypeStringDto } from 'app/api/apiClient/generated/types';

export const useGetUnitedStatesList = (): TypeStringDto[] => {
  const { t } = useTranslation('common');

  const unitedStatesList: TypeStringDto[] = [
    { id: 'AL', name: t('states.unitedStates.alabama', 'Alabama') },
    { id: 'AK', name: t('states.unitedStates.alaska', 'Alaska') },
    { id: 'AZ', name: t('states.unitedStates.arizona', 'Arizona') },
    { id: 'AR', name: t('states.unitedStates.arkansas', 'Arkansas') },
    { id: 'CA', name: t('states.unitedStates.california', 'California') },
    { id: 'CO', name: t('states.unitedStates.colorado', 'Colorado') },
    { id: 'CT', name: t('states.unitedStates.connecticut', 'Connecticut') },
    { id: 'DE', name: t('states.unitedStates.delaware', 'Delaware') },
    { id: 'DC', name: t('states.unitedStates.districtOfColumbia', 'District of Columbia') },
    { id: 'FL', name: t('states.unitedStates.florida', 'Florida') },
    { id: 'GA', name: t('states.unitedStates.georgia', 'Georgia') },
    { id: 'HI', name: t('states.unitedStates.hawaii', 'Hawaii') },
    { id: 'ID', name: t('states.unitedStates.idaho', 'Idaho') },
    { id: 'IL', name: t('states.unitedStates.illinois', 'Illinois') },
    { id: 'IN', name: t('states.unitedStates.indiana', 'Indiana') },
    { id: 'IA', name: t('states.unitedStates.iowa', 'Iowa') },
    { id: 'KS', name: t('states.unitedStates.kansas', 'Kansas') },
    { id: 'KY', name: t('states.unitedStates.kentucky', 'Kentucky') },
    { id: 'LA', name: t('states.unitedStates.louisiana', 'Louisiana') },
    { id: 'ME', name: t('states.unitedStates.maine', 'Maine') },
    { id: 'MD', name: t('states.unitedStates.maryland', 'Maryland') },
    { id: 'MA', name: t('states.unitedStates.massachusetts', 'Massachusetts') },
    { id: 'MI', name: t('states.unitedStates.michigan', 'Michigan') },
    { id: 'MN', name: t('states.unitedStates.minnesota', 'Minnesota') },
    { id: 'MS', name: t('states.unitedStates.mississippi', 'Mississippi') },
    { id: 'MO', name: t('states.unitedStates.missouri', 'Missouri') },
    { id: 'MT', name: t('states.unitedStates.montana', 'Montana') },
    { id: 'NE', name: t('states.unitedStates.nebraska', 'Nebraska') },
    { id: 'NV', name: t('states.unitedStates.nevada', 'Nevada') },
    { id: 'NH', name: t('states.unitedStates.newHampshire', 'New Hampshire') },
    { id: 'NJ', name: t('states.unitedStates.newJersey', 'New Jersey') },
    { id: 'NM', name: t('states.unitedStates.newMexico', 'New Mexico') },
    { id: 'NY', name: t('states.unitedStates.newYork', 'New York') },
    { id: 'NC', name: t('states.unitedStates.northCarolina', 'North Carolina') },
    { id: 'ND', name: t('states.unitedStates.northDakota', 'North Dakota') },
    { id: 'OH', name: t('states.unitedStates.ohio', 'Ohio') },
    { id: 'OK', name: t('states.unitedStates.oklahoma', 'Oklahoma') },
    { id: 'OR', name: t('states.unitedStates.oregon', 'Oregon') },
    { id: 'PA', name: t('states.unitedStates.pennsylvania', 'Pennsylvania') },
    { id: 'RI', name: t('states.unitedStates.rhodeIsland', 'Rhode Island') },
    { id: 'SC', name: t('states.unitedStates.southCarolina', 'South Carolina') },
    { id: 'SD', name: t('states.unitedStates.southDakota', 'South Dakota') },
    { id: 'TN', name: t('states.unitedStates.tennessee', 'Tennessee') },
    { id: 'TX', name: t('states.unitedStates.texas', 'Texas') },
    { id: 'UT', name: t('states.unitedStates.utah', 'Utah') },
    { id: 'VT', name: t('states.unitedStates.vermont', 'Vermont') },
    { id: 'VA', name: t('states.unitedStates.virginia', 'Virginia') },
    { id: 'WA', name: t('states.unitedStates.washington', 'Washington') },
    { id: 'WV', name: t('states.unitedStates.westVirginia', 'West Virginia') },
    { id: 'WI', name: t('states.unitedStates.wisconsin', 'Wisconsin') },
    { id: 'WY', name: t('states.unitedStates.wyoming', 'Wyoming') },
  ];

  return unitedStatesList;
};
